module.exports = __webpack_public_path__ + "static/media/checklist-white.61df3141.svg";